export class DnsConfigModel {
    public id?: string;
    public companyId: string;
    public subdomain: string;
    public theme?: any;
    public status: string;

    constructor(data: any) {
        this.id = data.id;
        this.companyId = data.companyId;
        this.subdomain = data.subdomain;
        this.theme = data.theme;
        this.status = data.status;
    }
}